"use strict";

export default class ForgottenController {
  errors = {
    forgotten: undefined,
  };
  submittedForgotten = false;
  submittedReset = false;
  submitted = false;
  forgottenMailSend = false;

  /*@ngInject*/
  constructor(
    $http,
    $location,
    gettextCatalog,
    LanguageService,
    PasswordService
  ) {
    "ngInject";
    this.$http = $http;
    this.location = $location;
    this.gettextCatalog = gettextCatalog;
    this.ls = LanguageService;
    this.getStrength = PasswordService.getStrength;

    this.parameters = $location.search();
    if (this.parameters && this.parameters.data) {
      this.resetPasswordView = true;
    }
  }

  generateLink(form) {
    this.submittedForgotten = true;

    if (form.$valid) {
      this.generateLinkOnProcess = true;
      this.$http
        .post("api/users/generate-link/", {
          email: this.user.email,
        })
        .then(() => {
          this.forgottenMailSend = true;
          this.generateLinkOnProcess = false;
        })
        .catch((err) => {
          this.generateLinkOnProcess = false;
          if (err.status == 404) {
            this.errors.forgotten = this.gettextCatalog.getString(
              "Adresse e-mail introuvable."
            );
          } else if (err.status == 500) {
            this.errors.forgotten = this.gettextCatalog.getString(
              "Une erreur technique est survenue durant le traitement de votre requête."
            );
          }
        });
    }
  }

  resetPassword(form) {
    this.submittedReset = true;

    if (form.$valid && this.parameters.data) {
      this.$http
        .put("api/users/reset-password/", {
          data: this.parameters.data,
          newPassword: this.user.password,
        })
        .then(() => {
          this.passwordChanged = true;
        })
        .catch((err) => {
          if (err && err.data) {
            err = err.data;
            this.errors = {};
            // Update validity of form fields that match the sequelize errors
            if (err.name == "dal-error") {
              for (var fname in err.fields) {
                if (err.fields.hasOwnProperty(fname)) {
                  form[fname].$setValidity("mongoose", false);
                  this.errors[fname] = this.ls.lang == "fr" ? err.fr : err.en;
                }
              }
            } else if (err.name == "dal-error-text") {
              this.errors.resetPassword =
                this.ls.lang == "fr" ? err.fr : err.en;
            } else {
              for (var fname in err.fields) {
                if (err.fields.hasOwnProperty(fname)) {
                  form[fname].$setValidity("mongoose", false);
                  this.errors[fname] = err.message;
                }
              }
            }
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/forgotten/forgotten.controller.js